import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import React from "react";

type DealDocumentTypeDisplayProps = {
  documentTypeName: string;
};
export const DealDocumentTypeDisplay = ({
  documentTypeName,
}: DealDocumentTypeDisplayProps) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(
    `(max-width:${theme.breakpoints.values.lg}px)`
  );

  return (
    <Box
      sx={{
        marginBottom: isSmallScreen ? "10px" : "0px",
        display: "flex",
        marginTop: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Typography variant="body1">{documentTypeName}</Typography>
      </Box>
    </Box>
  );
};
